import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { Rating } from "react-simple-star-rating";
import { MdPersonOutline } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { RxCross1 } from "react-icons/rx";
import cross from "../../assets/letter-x.png";
// import { FaTrashAlt } from "react-icons/fa";
import {
  favUnfav,
  getFavcars,
  cleanFavUnfav,
} from "../../redux/Slice/configSlice";
import { VscHeart, VscHeartFilled } from "react-icons/vsc";
import { toast } from "react-toastify";
const FavouriteCard = ({
  rating,
  carId,
  carImage,
  carName,
  carSeat,
  carPower,
  carSpeed,
  carMotor,
  carPrice,
  isUserFavId,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userDetail = useSelector((state) => state?.auth?.userDetail);
  const baseURL = useSelector((state) => state?.config?.baseURL);
  const favUnFavStatus = useSelector((state) => state?.config?.favUnFavStatus);
  const favUnFavDetail = useSelector((state) => state?.config?.favUnFavDetail);

  const signInId = userDetail?.data?._id;

  const favUnfavHandler = (carId, signInId) => {
    if (carId && signInId) {
      dispatch(favUnfav({ carId: carId, signInId: signInId }));
    }
  };

  useEffect(() => {
    if (favUnFavStatus === "fulfilled" && favUnFavDetail?.success === true) {
      dispatch(cleanFavUnfav());
      dispatch(getFavcars({ signInId: userDetail?.data?._id }));
      // toast(favUnFavDetail?.message)
    }
  }, [favUnFavDetail]);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  const handleButtonClick = () => {
    scrollToTop();
    navigate(`/cardetail/${carId}`);
  };
  return (
    <div className="card card-shadow border-0 h-100 position-relative">
      <div className="box rounded-top mx-auto box_div position-relative">
        <img
          src={`${baseURL}${carImage}`}
          className="fav-img rounded-top"
          alt="car-image"
        />
        <div className="heart-cls">
          {isUserFavId?.includes(userDetail?.data?._id) ? (
            <VscHeartFilled
              className="heart-icon pointer"
              onClick={() => favUnfavHandler(carId, signInId)}
            />
          ) : (
            <VscHeart
              className="heart-icon pointer"
              onClick={() => favUnfavHandler(carId, signInId)}
            />
          )}
          {/* <FaTrashAlt className='trash-icon-fav' /> */}
          {/* {isFavorite ? <VscHeartFilled className="heart-icon" onClick={() => favUnfavHandler(carId, signInId)} />
                                        : <VscHeart className="heart-icon" onClick={() => favUnfavHandler(carId, signInId)} />} */}
        </div>
      </div>
      <div className="card-body py-3">
        <div className="d-flex flex-column justify-content-evenly align-items-start">
          <div className="align-items-center d-flex justify-content-between w-100 mb-2">
            <h3 className="card-title text-capitalize font">{carName}</h3>
            <div>
              <p className="car-price m-0 fs-5 font">{carPrice}/day</p>
            </div>
          </div>
          <div className="mb-1">
            <div className="secondaryColor seater  fs14 d-flex gap-2 align-items-center">
              <p className="m-0 min-width70">Max Power</p> <span>:</span>{" "}
              <span className="text-secondary">{carPower} HP</span>
            </div>
            <div className="secondaryColor seater  fs14 d-flex gap-2 align-items-center">
              <p className="m-0 min-width70">Top Speed</p> <span>:</span>{" "}
              <span className="text-secondary">{carSpeed} km/h</span>
            </div>
            <div className="secondaryColor seater  fs14 d-flex gap-2 align-items-center">
              <p className="m-0 min-width70">Motor</p> <span>:</span>{" "}
              <span className="text-secondary">{carMotor} cc</span>
            </div>
          </div>
          <div className="align-items-center d-flex justify-content-between w-100 ">
            <p className="secondaryColor seater">
              <MdPersonOutline className="seater-icon clr-theme fs-6 icon-user-m" />{" "}
              <span>{carSeat} seater</span>{" "}
            </p>
            <Rating
              iconsCount={5}
              fillColor="#f1a545"
              readonly={true}
              initialValue={rating}
              size="16px"
            />
          </div>
        </div>

        <div className="w-100 mt-3">
          {/* <Link to="/cardetail" > */}
          <button
            onClick={handleButtonClick}
            type="button"
            className="btn w-100 img-btn primaryColor"
          >
            Rent Now
          </button>
          {/* </Link> */}
        </div>

        {/* <Link to="/cardetail" ><button onClick={scrollToTop} type="button" className="btn my-1 w-100 d-block d-md-none img-btn primaryColor">Rent Now</button></Link> */}

        <ReactTooltip id="remove-fav" place="bottom" content="Remove" />
      </div>
    </div>
  );
};

export default FavouriteCard;
